export default {
    methods: {
        errorApi(err, route) {
            var alertMsg = "";
            switch (err.id) {
                case 400:
                    alertMsg = err.message;
                    break;
                case 401:
                    alertMsg = err.message;
                    break;
                case 412:
                    alertMsg = "Token invalid";
                    break;
                default:
                    alertMsg = "Network connection error!";
            }

            if (this.alertModal != null) {
                this.alertModal
                    .clearModal()
                    .setMsg(alertMsg)
                    .show();
                if (route) {
                    this.alertModal.onClickOk(() => {
                        this.$router.push({ name: route });
                    });
                }
            } else if (this.modalController.alertModal != null) {
                this.modalController.alertModal
                    .clearModal()
                    .setMsg(alertMsg)
                    // .onClickOk(this.$router.push({name: route}))
                    .show();
            }
        },
        errorResponse(err) {
            if (err.id) {
                let msgContent = `(id: ${err.id || "-"}, code: ${err.code ||
                    "-"})`;
                this.modalController.alertModal
                    .clearModal()
                    .setTitle(err.message)
                    .setMsg(msgContent)
                    .show();
            } else {
                this.modalController.alertModal
                    .clearModal()
                    .setMsg("Network connection error!")
                    .show();
            }
        }
    }
};
